import { cookie } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/storage';
import formatPhoneNumber from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/formatters';
export var dynamicLinks = function dynamicLinks() {
  var currentPath = location.pathname;
  $('.navbar .nav-item a').each(function () {
    var href = $(this).attr('href').split(/\/|.html| /);
    if (!href[href.length - 1]) href.pop();
    if (currentPath.indexOf(href.join('/')) > -1) $(this).parent('li').addClass('active');
  });
  window.addEventListener('load', function () {
    $('svg').attr('focusable', 'false');
  });
  var links = document.querySelectorAll('a[href*="micro"]');

  if (links.length === 0) {
    links = document.querySelectorAll('a[href*="csbdm"]');
  }

  links.forEach(function (ele) {
    var href = ele.getAttribute('href');
    ele.setAttribute('href', "".concat(href).concat(location.search));
  });
};
export var ageModalLink = function ageModalLink() {
  // Link to cignaindividual.com in age modal.
  var vendorLink = document.getElementById('cignaindividual');
  console.log(vendorLink);

  if (vendorLink) {
    var campaignId = cookie.get('acxiomdatach01');
    var acxiomcht = cookie.get('acxiomdatacht');
    var call = formatPhoneNumber(cookie.get('campaign_phone'));
    vendorLink.setAttribute('href', "https://cignaindividual.com/public/Users/ExternalConnect.aspx?link_case=quote&campaign_id=".concat(campaignId, "&acxiomci01=").concat(campaignId, "&acxiomcht=").concat(acxiomcht, "&call=").concat(call, "&cid=s039"));
  }
};